import { Phone } from "lucide-react";

const FloatingCallButton = () => {
  return null;
};

export default FloatingCallButton;
